<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>予約</v-toolbar>
        <v-card-title class="noPaddingBtm">
          <v-col cols="7" class="noPadding">
            {{ this.viewTime }}
          </v-col>
          <!--
          <v-col cols="2" class="noPadding">
            <RyouBlackBtn :label="'数量変更'" :handlerClick="changeReserveNum">
            </RyouBlackBtn>
          </v-col>
          -->
        </v-card-title>
        <v-card-text>
          <v-card-text>
            <v-container style="height: 230px; overflow-y: auto">
              <v-row v-for="(item, index) in contentValue" :key="index">
                <!-- 2024.10.30 kouta.noborisaka 三井化学（市原工場）:cols="5"→:cols="colSize"に変更 -->
                <v-col :cols="colSize" class="pl-0">
                  <v-subheader :style="GetBgRGB(index)">
                    <div class="MenuStyle">
                      {{
                        item.menu == "" || item.menu == null
                          ? item.meal_name
                          : item.menu
                      }}
                    </div>
                  </v-subheader>
                </v-col>
                <!-- 2024.10.30 kouta.noborisaka 三井化学（市原工場）:cols="5"→:cols="colSize"に変更 -->
                <v-col :cols="colSize" style="padding: 12px 0px">
                  <v-subheader>
                    <v-icon
                      large
                      color="blue"
                      v-if="item.reserve_flg"
                      @click="reserveFlgChange(item)"
                      :disabled="!item.offer_flg_mc"
                    >
                      mdi-check-circle
                    </v-icon>
                    <v-icon
                      large
                      v-if="!item.reserve_flg"
                      @click="reserveFlgChange(item)"
                      :disabled="!item.offer_flg_mc"
                    >
                      mdi-checkbox-blank-circle-outline
                    </v-icon>
                    <v-col class="pl-0">
                      {{ item.meal_name }}
                    </v-col>
                    <v-icon
                      large
                      color="green"
                      v-if="item.holding_flg"
                      @click="holdingFlgChange(item)"
                      :disabled="!item.offer_flg_mc"
                    >
                      mdi-check-circle
                    </v-icon>
                    <v-icon
                      large
                      v-if="!item.holding_flg"
                      @click="holdingFlgChange(item)"
                      :disabled="!item.offer_flg_mc"
                    >
                      mdi-checkbox-blank-circle-outline
                    </v-icon>
                    {{ "残" }}
                  </v-subheader>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <ryou-black-btn
              :label="'閉じる'"
              :handlerClick="handleCancel"
              :disabled="closeBtnCtrl"
              :iconCls="'mdi-close'"
            >
            </ryou-black-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card-text>
      </v-card>
      <MealReserveChangeNumDialog
        ref="changeNumDialog"
      ></MealReserveChangeNumDialog>
    </v-container>
  </v-dialog>
</template>

<script>
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import MealReserveChangeNumDialog from "./MealReserveChangeNumDialog.vue";

export default {
  name: "MealReservationDayDialog",
  components: {
    RyouBlackBtn,
    MealReserveChangeNumDialog,
  },
  data() {
    return {
      dialog: false,
      closeBtnCtrl: false,
      time: "",
      viewTime: "",
      contentValue: [],
      groupOptionValue: "",
      reserveUserOptionValue: "",
      colSize: "5", // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:列幅指定用のプロパティを定義
    };
  },
  watch: {},
  methods: {
    //クリックを閉じる
    handleCancel() {
      this.close();
    },
    //ページローディング要求インターフェース、取得値
    // パラメータ1:ダイアログデータ、パラメータ2:物件グループID、パラメータ3:ユーザID、パラメータ4:カレンダータイプ
    // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4、スマホ表示の設定を追加。Start
    getInputValue(
      value,
      buildGroupSelectValue,
      reserveUserSelectValue,
      calendarTypeValue
    ) {
      // スマホ表示の場合に、メニュー名とチェックマークを2行に分けて表示する。
      if (calendarTypeValue == "week") {
        this.colSize = "11";
      }
      // 2024.10.24 kouta.noborisaka 三井化学（市原工場）:パラメータ4、スマホ表示の設定を追加。End
      if (buildGroupSelectValue) {
        this.groupOptionValue = buildGroupSelectValue;
      }
      if (reserveUserSelectValue) {
        this.reserveUserOptionValue = reserveUserSelectValue;
      }
      //タイプ判定
      if (value instanceof Object) {
        for (let dialogDataIndex in value) {
          this.time = dialogDataIndex;

          let timelist = dialogDataIndex.split("-");
          this.viewTime =
            timelist[0] +
            "/" +
            (timelist[1][0] == "0" ? timelist[1][1] : timelist[1]) +
            "/" +
            (timelist[2][0] == "0" ? timelist[2][1] : timelist[2]);

          this.contentValue = value[dialogDataIndex];
          if (this.contentValue.length != 0) {
            this.contentValue.forEach((item) => {
              item.reserve_flg =
                item.reserve_flg == ""
                  ? false
                  : Boolean(Number(item.reserve_flg));
              item.holding_flg =
                item.holding_flg == ""
                  ? false
                  : Boolean(Number(item.holding_flg));
              item.offer_flg_mc =
                item.offer_flg_mc == ""
                  ? false
                  : Boolean(Number(item.offer_flg_mc));
            });
          }
        }
      }

      this.open();
    },
    // パラメータをクリア
    clearParameters() {
      this.contentValue = [];
      this.groupOptionValue = "";
      this.reserveUserOptionValue = "";
    },
    close() {
      this.dialog = false;

      this.clearParameters();
      this.$emit("reCalendar");
      this.$emit("reCalc", true);
    },
    open() {
      this.dialog = true;
    },
    GetBgRGB(value) {
      let BgRGB = [
        "#FF9800", //オレンジ
        "#673AB7", //深紫
        "#4CAF50", //緑
        "#E91E63", //ピンク
        "#3F51B5", //インディゴ
        "#009688", //teal
        "#FF5722", //深オレンジ
        "#8BC34A", //light-green
        "#D32F2F", //red darken-2
        "#1565C0", //blue darken-3
      ];
      if (!this.contentValue[value].offer_flg_mc) {
        return {
          background: "#bebebe",
        };
      } else {
        return {
          background: BgRGB[value],
        };
      }
    },
    reserveFlgChange(value) {
      //変更前の状態を保持
      let holding_flg_bak = value.holding_flg;

      value.reserve_flg = !value.reserve_flg;
      //予約なしに変更時、取置有無をなしにする
      if (!value.reserve_flg) {
        if (value.holding_flg) {
          value.holding_flg = false;
        }
      }
      let params = {
        build_group_id: this.groupOptionValue,
        input_date: this.time,
        edit_user_id: this.reserveUserOptionValue,
        reserve_entity: [
          {
            meal_class: value.meal_class,
            reserve_flg: Number(value.reserve_flg).toString(),
            holding_flg: Number(value.holding_flg).toString(),
          },
        ],
        user_id: this.$store.getters.getUserId,
      };

      this.closeBtnCtrl = true;
      this.putRequest(
        "/mealReservation/mealReserveUpdate",
        params,
        this.$store.getters.getUserToken
      ).then((result) => {
        //更新不可の場合はフラグをもとに戻す
        if (!result.success) {
          value.reserve_flg = !value.reserve_flg;
          value.holding_flg = holding_flg_bak;
        }
        //予約なしに変更時、画面表示切替のため追加予約数を０にする
        else if (!value.reserve_flg) {
          value.additional_num = 0;
        }
        this.closeBtnCtrl = false;
      });
    },
    holdingFlgChange(value) {
      //変更前の状態を保持
      let reserve_flg_bak = value.reserve_flg;

      value.holding_flg = !value.holding_flg;
      //取置ありに変更時、予約有無をありにする
      if (value.holding_flg) {
        if (!value.reserve_flg) {
          value.reserve_flg = true;
        }
      }

      let params = {
        build_group_id: this.groupOptionValue,
        input_date: this.time,
        edit_user_id: this.reserveUserOptionValue,
        reserve_entity: [
          {
            meal_class: value.meal_class,
            reserve_flg: Number(value.reserve_flg).toString(),
            holding_flg: Number(value.holding_flg).toString(),
          },
        ],
        user_id: this.$store.getters.getUserId,
      };
      this.closeBtnCtrl = true;
      this.putRequest(
        "/mealReservation/mealReserveUpdate",
        params,
        this.$store.getters.getUserToken
      ).then((result) => {
        //更新不可の場合はフラグをもとに戻す
        if (!result.success) {
          value.holding_flg = !value.holding_flg;
          value.reserve_flg = reserve_flg_bak;
        }
        this.closeBtnCtrl = false;
      });
    },
    changeReserveNum() {
      this.$refs.changeNumDialog.getInputValue(
        this.contentValue,
        this.groupOptionValue,
        this.reserveUserOptionValue,
        this.time
      );
    },
  },
};
</script>

<style scoped>
.noPadding {
  padding: 0px;
}

.noPaddingBtm {
  padding-bottom: 0px;
}

.noPaddingTopBtm {
  padding-top: 0px;
  padding-bottom: 0px;
}

.HigotoTextBox {
  outline: 1px solid rgb(0, 225, 255);
}

.MenuStyle {
  width: 100%;
  height: 100%;
  color: white;
  font-weight: bold;
  text-align: center;
  /* 2024.10.24 kouta.noborisaka 三井化学（市原工場）:「line-height: 48px;」を削除。メニュー名を中央に表示するスタイルを3つ追加。 Start */
  display: flex;
  justify-content: center;
  align-items: center;
  /* 2024.10.24 kouta.noborisaka 三井化学（市原工場）:「line-height: 48px;」を削除。メニュー名を中央に表示するスタイルを3つ追加。 End */
}
</style>
